import ProxyBase from '../../../../core/proxies/ProxyBase'

class CartProxy extends ProxyBase {
  getCartQuantity() {
    return this.get('CartAndOrder/CartItems/Count')
  }
}

export default new CartProxy()
